// extracted by mini-css-extract-plugin
export default {"floatingBtn":"index_floatingBtn__j6SyH"};